// Layout compartido de las pantallas autenticadas (fix navegación
// ADR-025): cabecera global, contenido y menú inferior compartidos,
// en vez de pintar BottomNav a mano en cada página.
//
// - Cabecera global: ESTILO HOME (marca + campana), SIN botón atrás —
//   la navegación hacia atrás se hace con el gesto del móvil
//   (feedback usuario 2026-08-18). No se pinta en las rutas que ya
//   tienen cabecera propia (Home con su marca y los flujos internos
//   con su cabecera de sección).
// - Contenido: <Outlet /> con padding inferior para que el BottomNav
//   fijo nunca tape el final de la página.
// - BottomNav: fijo abajo; el editor de parte usa sus propias acciones.

import { matchPath, Outlet, useLocation } from 'react-router-dom';

import { AppHeaderContent } from '@/components/AppHeaderContent';

import { BottomNav } from '@/components/BottomNav';

// Rutas con cabecera propia (marca de la Home o cabecera interna de
// sección) — el layout no añade otra encima.
const RUTAS_SIN_CABECERA_GLOBAL: string[] = [
  '/',
  '/naves/:naveId',
  '/naves/:naveId/pesajes/nuevo',
  '/camadas/nueva',
  '/ajustes/naves/nueva',
  '/ajustes/naves/:naveId',
  '/ajustes/naves/:naveId/sensores',
  '/camadas/:camadaId/asignar-lotes',
  '/camadas/:camadaId/cerrar',
  '/camadas/:camadaId/registro-diario',
  '/camadas/:camadaId/entradas-animales',
  '/camadas/:camadaId/entradas-animales/nueva',
  '/camadas/:camadaId/entradas-animales/:entradaId/editar',
  '/camadas/:camadaId/entregas-pienso/nueva',
  // Detalle de camada y sus listados completos (ADR-036).
  '/camadas/:camadaId/partes',
  '/camadas/:camadaId/salidas',
  '/camadas/:camadaId/salidas/nueva',
  '/camadas/:camadaId/salidas/:salidaId/editar',
  '/camadas/:camadaId/salidas/:salidaId/peso',
  '/camadas/:camadaId/entregas-pienso',
  '/camadas/:camadaId/lotes/:loteId/muestreos',
  // El alias /naves/:naveId/muestreos renderiza directamente el
  // listado de muestreos sin redirect, así que también oculta la
  // cabecera global.
  '/naves/:naveId/muestreos',
];

export function AppLayout() {
  const location = useLocation();
  const parteEditor =
    !!matchPath('/camadas/:camadaId/registro-diario', location.pathname) &&
    /^-?[1-9]\d*$/.test(new URLSearchParams(location.search).get('lote') ?? '');
  const mobileForm = [
    '/naves/:naveId/pesajes/nuevo',
    '/camadas/:camadaId/entregas-pienso/nueva',
    '/camadas/:camadaId/salidas/nueva',
    '/camadas/:camadaId/salidas/:salidaId/editar',
    '/camadas/:camadaId/salidas/:salidaId/peso',
    '/camadas/nueva',
    '/ajustes/naves/nueva',
    '/ajustes/naves/:naveId',
    '/ajustes/naves/:naveId/sensores',
    '/camadas/:camadaId/asignar-lotes',
    '/camadas/:camadaId/cerrar',
    '/camadas/:camadaId/entradas-animales/nueva',
    '/camadas/:camadaId/entradas-animales/:entradaId/editar',
  ].some((pattern) => matchPath(pattern, location.pathname));

  const tieneCabeceraPropia = RUTAS_SIN_CABECERA_GLOBAL.some((patron) =>
    matchPath(patron, location.pathname),
  );

  return (
    <div className="ui-app-shell min-h-screen bg-background text-text-primary">
      {!tieneCabeceraPropia && (
        <header
          data-testid="app-header"
          className="ui-global-header container mx-auto mb-3 max-w-md px-4"
        >
          <AppHeaderContent />
        </header>
      )}

      {/* Reserva la altura real de la barra y el área segura inferior. */}
      <div
        className={`ui-app-content ${parteEditor ? 'ui-part-editor' : ''} ${mobileForm ? 'ui-mobile-form' : ''}`}
      >
        <Outlet />
      </div>

      {!parteEditor && !mobileForm && <BottomNav />}
    </div>
  );
}

export default AppLayout;
